'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$190() {
  this.c3o = null;
  this.c3m = null;
  this.c3n = false;
  this.c3k = null;
  this.c3l = false;
  this.c3p = false;
  this.c3q = false;
  this.c3o = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$190 as $c_Lpresto_types$$anon$190 };
$p = $c_Lpresto_types$$anon$190.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$190;
/** @constructor */
function $h_Lpresto_types$$anon$190() {
}
export { $h_Lpresto_types$$anon$190 as $h_Lpresto_types$$anon$190 };
$h_Lpresto_types$$anon$190.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.c3o;
});
$p.t = (function() {
  if ((!this.c3n)) {
    this.c3m = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3n = true;
  }
  return this.c3m;
});
$p.ag = (function() {
  if ((!this.c3l)) {
    this.c3k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3l = true;
  }
  return this.c3k;
});
$p.v = (function() {
  if ((!this.c3q)) {
    this.c3p = false;
    this.c3q = true;
  }
  return this.c3p;
});
$p.ad7 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ae = (function(a) {
  return this.ad7(a);
});
var $d_Lpresto_types$$anon$190 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$190, "presto.types$$anon$190", ({
  Yi: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$190 as $d_Lpresto_types$$anon$190 };
//# sourceMappingURL=presto.types$$anon$190.js.map
